import Link from '@mui/material/Link'
import React, { PropsWithChildren, ReactElement } from 'react'
import { LinkProps, Link as RouterLink } from 'react-router'

type StyledLinkProps = {
  to: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

const MyLink = React.forwardRef<HTMLAnchorElement, LinkProps>(function MyLink(props, ref) {
  return <RouterLink {...props} ref={ref} />
})

export default function StyledLink({ children, ...rest }: PropsWithChildren<StyledLinkProps>): ReactElement {
  return (
    <Link underline="none" component={MyLink} {...rest}>
      {children}
    </Link>
  )
}
